import { checkLocalStorageVersion } from "./utils/check-local-storage-version";

checkLocalStorageVersion();
